import ReviewAccordionItem from './ReviewAccordionItem';

export default ReviewAccordionItem;
